import { bulk } from './update';

export function request(data) {
    data.display = !!data.display;
    data.active = !!data.active;


    return {
        type: 'COMPETITIONS_CREATE_REQUEST',
        data
    };
}

export function error(errors) {
    return {
        type: 'COMPETITIONS_CREATE_ERROR',
        errors
    };
}

export function finish(competition) {
    return (dispatch) => {
        dispatch(bulk([ competition ]));

        dispatch({
            type: 'COMPETITIONS_CREATE_FINISH',
            competition
        });
    };
}

export function clear() {
    return {
        type: 'COMPETITIONS_CREATE_CLEAR'
    };
}
